/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

/**
 * RisksSection — risk / mitigation table with expandable tooltips.
 */
import { motion } from "framer-motion";
import { AlertTriangle, Shield } from "lucide-react";
import PitchSection from "../PitchSection";
import SectionLabel from "../SectionLabel";
import InfoTooltip from "../InfoTooltip";

export default function RisksSection({ data }) {
  return (
    <PitchSection id="risks">
      <SectionLabel>{data.label}</SectionLabel>
      <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-10 leading-tight">
        {data.title}
      </h2>

      <div className="space-y-3">
        {data.items.map((item, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            className="bg-[#0F1826]/60 border border-white/8 rounded-xl p-5"
          >
            <div className="flex flex-col sm:flex-row sm:items-start gap-3">
              {/* Risk */}
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <AlertTriangle className="w-4 h-4 text-amber-400/70" />
                  <span className="text-base font-medium text-white flex items-center">
                    {item.risk}
                    {item.tooltip && <InfoTooltip>{item.tooltip}</InfoTooltip>}
                  </span>
                </div>
              </div>
              {/* Mitigation */}
              <div className="flex-1 flex items-start gap-2">
                <Shield className="w-4 h-4 text-[#4FA9A1] mt-0.5 flex-shrink-0" />
                <p className="text-base text-gray-400 leading-relaxed">{item.mitigation}</p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </PitchSection>
  );
}
